// removed by extract-text-webpack-plugin
module.exports = {"item":"Ticket__item___20OGU","meta":"Ticket__meta___3ROM6","panelModerator":"Ticket__panelModerator___RX9GR","heading":"Ticket__heading___1J30t","content":"Ticket__content___2BQ0U","sidebar":"Ticket__sidebar___2y27g","badge":"Ticket__badge___eTBty","category":"Ticket__category___cI3gf","categoryBlock":"Ticket__categoryBlock___3XkaO","form":"Ticket__form___8gwPn","formLeft":"Ticket__formLeft___ZSmTz","formRight":"Ticket__formRight___Q2ttk","submit":"Ticket__submit___oY-f3","markdownTip":"Ticket__markdownTip___34t9i"};


//////////////////
// WEBPACK FOOTER
// ./modules/Ticket.css
// module id = 645
// module chunks = 0